import styled from 'styled-components';

export const CardContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray4};
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const PriceAgreementContainer = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  .hefesto-tag .hefesto-tag--success {
    font-size: 0.88rem;
  }
`;

export const NoImageThumbnail = styled.div`
  background: ${({ theme }) => theme.colors.lightGray3};
  min-height: 8rem;
  max-height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  font-size: 0.88rem;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const CardContent = styled.div`
  padding: 0.5rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const CodeInfo = styled.div`
  font-size: 0.88rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ProductInfo = styled.div<{
  $title?: boolean;
}>`
  font-size: 1rem;
  color: ${({ theme, $title }) =>
    $title ? theme.colors.grayDark3 : theme.colors.grayDark4};
  font-weight: ${({ $title }) => ($title ? '600' : '400')};
  font-family: 'Source Sans Pro';
`;

export const ProductPrice = styled.div`
  font-family: 'Source Sans Pro';
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${({ theme }) => theme.colors.grayDark3};
  margin-bottom: 0.5rem;
  margin-top: 12px;
  font-weight: 600;
`;

export const AditionalInfoContainer = styled.div`
  margin-bottom: 1rem;
`;

export const AdditionalInfo = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: #414e55;
  color: ${({ theme }) => theme.colors.grayDark4};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  min-height: 252px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  button {
    height: 3rem;
  }
`;

export const WishlistButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 1.5rem;
    height: 1.5rem;
    transition: opacity 0.15s ease, transform 0.15s ease;
  }

  &:hover img {
    opacity: 0.75;
    transform: scale(1.1);
  }
`;
